module.exports = __webpack_public_path__ + "img/loader.7f154035.gif";